import { SvgColor } from 'src/components/svg-color';
import { Iconify } from 'src/components/iconify';
import { getUserRoleFromToken } from 'src/utils/jwt';

import { OvertimePendingBadge } from './components/overtime-pending-badge';
import { SuspiciousLoginPendingBadge } from './components/suspicious-login-pending-badge';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor width="100%" height="100%" src={`/assets/icons/navbar/${name}.svg`} />
);

export const navData = [
  {
    title: 'Anasayfa',
    path: '/dashboard',
    icon: icon('ic-analytics'),
  },
  {
    title: 'Firmalar',
    path: '/dashboard/companies',
    icon: icon('ic-company'),
    showForRoles: ['ROLE_SUPER_ADMIN'],
  },
  {
    title: 'Şubeler',
    path: '/dashboard/branches',
    icon: icon('ic-branch'),
  },
  {
    title: 'Çalışanlar',
    path: '/dashboard/employee',
    icon: icon('ic-user'),
  },
  // {
  //   title: 'Çalışan Transferi',
  //   path: '/dashboard/employee/transfer',
  //   icon: <Iconify icon="material-symbols:compare-arrows" width="100%" height="100%" />,
  //   showForRoles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
  // }, // Artık kullanılmıyor - Branch details içinde entegre edildi
  {
    title: 'İzin Talepleri',
    path: '/dashboard/permissions',
    icon: icon('ic-permission'),
  },
  {
    title: 'Mesai Onayları',
    path: '/dashboard/overtime',
    icon: <Iconify icon="solar:alarm-bold-duotone" width="100%" height="100%" />,
    info: <OvertimePendingBadge />,
  },
  {
    title: 'Şüpheli Girişler',
    path: '/dashboard/suspicious-logins',
    icon: <Iconify icon="solar:shield-warning-bold-duotone" width="100%" height="100%" />,
    info: <SuspiciousLoginPendingBadge />,
    showForRoles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
  },
  {
    title: 'Sistem Logları',
    path: '/dashboard/logs',
    icon: <Iconify icon="solar:bug-bold-duotone" width="100%" height="100%" />,
    showForRoles: ['ROLE_SUPER_ADMIN'],
  },
  {
    title: 'Güvenlik Olayları',
    path: '/dashboard/security-logs',
    icon: <Iconify icon="solar:shield-warning-bold-duotone" width="100%" height="100%" />,
    showForRoles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
  },
  {
    title: 'Cihaz Sürümleri',
    path: '/dashboard/device-versions',
    icon: <Iconify icon="solar:smartphone-bold-duotone" width="100%" height="100%" />,
    showForRoles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
  },
  {
    title: 'Raporlar',
    path: '/dashboard/reports',
    icon: <Iconify icon="solar:chart-2-bold-duotone" width="100%" height="100%" />,
    showForRoles: ['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
  },
];

// Kullanıcının rolüne göre menü öğelerini filtrele
export const getFilteredNavData = () => {
  const userRole = getUserRoleFromToken();

  // console.log('Kullanıcının mevcut rolü:', userRole);

  return navData.filter(item => {
    // Eğer showForRoles tanımlanmamışsa tüm roller görebilir
    if (!item.showForRoles) {
      return true;
    }
    
    // Eğer showForRoles tanımlanmışsa, kullanıcının rolü listede olmalı
    return item.showForRoles.includes(userRole || '');
  });
};
